import { memo, useMemo } from 'react';
import {
  Card,
  CardHeader,
  Checkbox,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import * as moment from 'moment/moment';
import PropTypes from 'prop-types';
import { toCurrency } from '../../../utils/formatNumber';

CustomList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  checked: PropTypes.array,
  handleToggle: PropTypes.func
};

function CustomList({ title, items, checked, handleToggle }) {
  const checkedIds = useMemo(() => new Set(checked || []), [checked]);

  return (
    <Card sx={{ borderRadius: 1.5 }}>
      <CardHeader title={title} sx={{ p: 2 }} />

      <Divider />

      <List
        dense
        component="div"
        role="list"
        sx={{
          // width: 700,
          height: 220,
          overflow: 'auto'
        }}
      >
        {items.map((item, idx) => {
          const labelId = `transfer-list-all-item-${item}-label`;
          return (
            <ListItemButton key={item.id || idx} role="listitem" onClick={() => handleToggle && handleToggle(item)}>
              <ListItemIcon sx={{ textAlign: 'right' }}>
                <Checkbox
                  checked={checkedIds.has(item.id)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${item.invoiceNumber}`} sx={{ textAlign: 'left' }} />
              <ListItemText
                id={labelId}
                primary={`${moment(item.date).format('DD/MM/yy')}`}
                sx={{ textAlign: 'left' }}
              />
              <ListItemText id={labelId} primary={`${toCurrency(item.amount, 2)}`} sx={{ textAlign: 'right' }} />
              {/* <ListItemText id={labelId} primary={`${toCurrency(item.totalTax, 2)}`} sx={{ textAlign: 'right' }} /> */}
              <ListItemText id={labelId} primary={`${toCurrency(item.total, 2)}`} sx={{ textAlign: 'right' }} />
            </ListItemButton>
          );
        })}
      </List>
    </Card>
  );
}

export default memo(CustomList);
